import dayjs from "dayjs";
import { Badge } from "@/components/ui";

/**
 * Gestión Documental · fase 4 · vigencia de un documento: «Vence dd/mm/aaaa», «Vencido» o «Sin fecha de
 * emisión» (con vigencia pero sin fecha: no vence · decisión del usuario 09/10/2026). Sin vigencia no
 * pinta nada.
 */
export function VigenciaBadge({
  manejaVigencia,
  fechaVencimiento,
  vencido,
}: {
  manejaVigencia?: boolean;
  fechaVencimiento?: string | null;
  vencido?: boolean;
}) {
  if (fechaVencimiento) {
    const fecha = dayjs(fechaVencimiento).format("DD/MM/YYYY");
    return vencido ? (
      <Badge size="xs" color="peligro" title={`Venció el ${fecha}`}>
        Vencido · {fecha}
      </Badge>
    ) : (
      <Badge size="xs" color="info" title={`Vigente hasta el ${fecha}`}>
        Vence {fecha}
      </Badge>
    );
  }
  if (!manejaVigencia) return null;
  return (
    <Badge size="xs" color="slate" title="Tiene vigencia pero no se capturó su fecha de emisión · no se considera vencido">
      Sin fecha de emisión
    </Badge>
  );
}
